const STRIP_HUBL_TOKENS = /\{\{.*}}/g;
const STRIP_HUBL_TAGS = /\{%.*%}/g;
const ENSURE_NEWLINE_AFTER_P_TAGS = /<\/p>/g;
const ENSURE_NEWLINE_AFTER_HEADING_TAGS = /<\/h[1-6]>/g;
const STRIP_HTML_TAGS = /<[^>]*>?/gm;
const ENSURE_MAX_TWO_CONSECUTIVE_LINEBREAKS = /\n\s*\n\s*\n/g;
export function stripTags(html) {
  return html.replace(STRIP_HUBL_TOKENS, '').replace(STRIP_HUBL_TAGS, '').replace(ENSURE_NEWLINE_AFTER_P_TAGS, '\n\n') // ensure a newline after paragraphs
  .replace(ENSURE_NEWLINE_AFTER_HEADING_TAGS, '\n\n') // ensure a newline after headings
  .replace(STRIP_HTML_TAGS, '') // strip rest of HTML tags & comments
  .replace(ENSURE_MAX_TWO_CONSECUTIVE_LINEBREAKS, '\n\n') // ensure no more than 2 consecutive newlines
  .replaceAll('&nbsp;', '') // eliminate remaining non-break space tokens (TODO rest of entites?)
  .trim();
}